﻿import { onEvent } from "./_dom";
import { Globalize } from "./_globalize";

let decSep;

function init(context, selector = "input.number") {
	onEvent(context || document, selector, "keydown", (e, input) => {
		if (e.key === "." && e.location === 3) {
			decSep ??= Globalize.culture().numberFormat["."];
			// numpad "."
			var start = input.selectionStart;
			var end = input.selectionEnd;
			var v = input.value;
			input.value = v.substring(0, start) + decSep + v.substring(end);
			input.selectionStart = input.selectionEnd = start + 1;
			e.stopPropagation();
			e.preventDefault();
		}
	});
}

export { init };